/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "antd";
import omit from "lodash/omit";
import BulkServices from "../../components/BulkServices/BulkServices";
import { clearServices, fetchServiceTypes, searchServices } from "../../store/slices/services";
import {
  fetchProducts,
  fetchServiceMode,
  fetchServiceStatus,
} from "../../store/slices/rtkDictionaries";
import { checkIsLoaded } from "../../lib/utils/checkLoadingStatus";
import { useAppSelector } from "../..";
import { fetchBlockingTypes } from "../../store/slices/blocking";
import useBlockingMode from "../../lib/hooks/useBlockingMode";
import { agreementsSearchActions } from "../../store/slices/agreementsSearch/agreementsSearch";
import { toHttpFormatStartOfDay } from "../../lib/utils";

const BulkServicesContainer = () => {
  const dispatch = useDispatch();
  const [isLoaded, setIsLoaded] = useState(false);
  const [filteredServiceStatuses, setFilteredServiceStatuses] = useState();
  const [form] = Form.useForm();
  const {
    serviceMode: serviceModes,
    serviceStatus,
    productsLoading,
    serviceStatusLoading,
    serviceModeLoading,
  } = useSelector((state) => state.rtkDictionaries);

  const { companyIdentityAttribute } = useAppSelector((state) => state.tenants.tenantProperties);

  const { blockingTypesLoading } = useAppSelector((state) => state.blocking);

  const isBlockingMode = useBlockingMode();

  const defaultServicesSearchParams = {
    serviceStatusId: [],
    serviceTypeId: [],
    serviceModeId: null,
    tariffName: "",
  };

  // Очистка списка accountSelect при входе и выходе
  useEffect(() => {
    dispatch(agreementsSearchActions.cleanAccounts());
    return () => dispatch(agreementsSearchActions.cleanAccounts());
  }, []);

  useEffect(() => {
    if (!checkIsLoaded(productsLoading)) dispatch(fetchProducts());
    if (!checkIsLoaded(serviceStatusLoading)) dispatch(fetchServiceStatus());
    if (!checkIsLoaded(serviceModeLoading)) dispatch(fetchServiceMode());
    if (isBlockingMode && !checkIsLoaded(blockingTypesLoading)) dispatch(fetchBlockingTypes());
    dispatch(fetchServiceTypes());
    return () => {
      setIsLoaded(false);
      dispatch(clearServices());
    };
  }, []);

  useEffect(() => {
    setFilteredServiceStatuses(serviceStatus);
  }, [serviceStatus]);

  const handleSearchServices = (values) => {
    const id = values.serviceIds?.split(/\D/).filter(Number);
    const serviceMode = serviceModes.find((item) => item.id === form.getFieldValue("serviceModeId"))
      ?.alias;

    const searchParams = {
      ...omit(values, "serviceModeId", "serviceIds", "onDate"),
      serviceMode,
      id,
      extendedOfferingInfo: false,
      onDate: values.onDate ? toHttpFormatStartOfDay(values.onDate) : undefined,
    };
    if (values["organization.property.stringValue"]) {
      searchParams["organization.property.typeAlias"] = companyIdentityAttribute;
    }
    dispatch(searchServices(searchParams));
    setIsLoaded(true);
  };

  const resetSearchServices = () => {
    form.resetFields();
    setIsLoaded(false);
    dispatch(agreementsSearchActions.cleanAccounts());
  };

  return (
    <div className="container_height">
      <BulkServices
        handleSearchServices={handleSearchServices}
        resetSearchServices={resetSearchServices}
        isLoaded={isLoaded}
        defaultServicesSearchParams={defaultServicesSearchParams}
        form={form}
        filteredServiceStatuses={filteredServiceStatuses}
      />
    </div>
  );
};

export default BulkServicesContainer;
